import { AccountSelectV2 } from '@frontend/account/select';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useAccountConstraintDataInput from './account-constraint-data-input.controller';

const ID = 'account-constraint-data-input';
export interface AccountConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const AccountConstraintDataInput = (props: AccountConstraintDataInputProps) => {
    const viewProps = useAccountConstraintDataInput(props);
    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <AccountSelectV2
                required
                value={viewProps.formValues?.account_id ?? null}
                onChange={(v) => {
                    props.dispatch(updateField({ formId: props.formId, key: 'data', value: v ? { account_id: v } : undefined }));
                }}
                disabled={!!viewProps.formValues?.account_id}
            />
        </div>
    );
};

export default AccountConstraintDataInput;
